<ng-container *ngIf="reasons$ | async as reason; else loading">
  <app-alert
    style="margin-bottom: 40px"
    class="flex-col-container mt-32"
    type="warning"
    icon="warning_amber"
    lineHeight="lh-1"
    [message]="cardType === CARD_TYPE.VIRTUAL ? ('MODAL_CARDS_REPLACEMENT.ALERT_VIRTUAL' | translate ):('MODAL_CARDS_REPLACEMENT.ALERT_PHYSICAL' | translate ) ">
  </app-alert>

  <form class="w-95 mt-10 m-auto" [formGroup]="replacementForm">
    <mat-form-field class="w-all mt-15 px-8">
      <mat-label>{{ 'MODAL_CARDS_REPLACEMENT.SELECT_PLACEHOLDER' | translate}}</mat-label>
      <mat-select class="select-padding" formControlName="reason">
        <mat-option *ngFor="let item of reason" [value]="item"> {{ item.description }} </mat-option>
      </mat-select>
    </mat-form-field>
  </form>
</ng-container>

<ng-template #loading>
  <app-skeleton-container [errorMessage]="this.errorMessage" [errorThrown]="this.errorThrown">
    <div class="flex-row-container gap-16">
      <div class="flex-col-container flex-1">
        <app-skeleton-text height="64px" width="100%" [count]="1"></app-skeleton-text>
        <app-skeleton-text className="mt-16" height="72px" width="100%" [count]="1"></app-skeleton-text>
      </div>
    </div>
  </app-skeleton-container>
</ng-template>
